var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelopersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    viewBox: "0 0 31 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2873 0H10.9023C10.2997 0 9.81287 0.497185 9.81287 1.11258V9.31788H1.77796C1.17534 9.31788 0.688477 9.81507 0.688477 10.4305V19.8874C0.688477 20.5028 1.17534 21 1.77796 21H20.1629C20.7655 21 21.2524 20.5028 21.2524 19.8874V11.6821H29.2873C29.8899 11.6821 30.3768 11.1849 30.3768 10.5695V1.11258C30.3768 0.497185 29.8899 0 29.2873 0ZM18.9373 18.6358H12.128V11.6821H18.9373V18.6358ZM28.0616 9.31788H21.2524V2.36424H28.0616V9.31788Z",
    fill: "url(#paint0_linear_66_604)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_604",
    x1: 7.61575,
    y1: 5,
    x2: 25.5428,
    y2: 16.8272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E271CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AB8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopersIcon);
export default __webpack_public_path__ + "static/media/developers-icon.c24f9faf1966778e384328bd8d823c18.svg";
export { ForwardRef as ReactComponent };